module.exports = __webpack_public_path__ + "static/media/地震發生時有沒有到空曠處避難.c41b1810.png";